<template>
    <MainContentSearchable title="Listado de acreditaciones" id="acreditaciones" v-model="filters" :meta="loading ? {} : acreditaciones.meta" @updated="debouncedGetAcreditaciones">
        <template v-slot:header>
            <div class="ml-auto">
                <a :href="url_imprimir_todas()" class="btn btn-primary mb-3 mr-3" target="_blank" v-if="acreditaciones.data.length > 1">Descargar Acreditaciones</a>
                <router-link :to="{ name: 'back.events.acreditaciones.crear', params: { evento_id: evento_id } }" class="btn btn-primary mb-3" target="blank">Nueva acreditación</router-link>
            </div>
        </template>
        <template v-slot:content>
            <div v-if="!loading">
                <div class="table-responsive has-options">
                    <b-table hover :items="acreditaciones.data" :fields="fields" id="acreditaciones-table">
                        <template #cell(puertas)="{ item }">
                            {{ item.puertasSelect.map(i => i.nombre).join(', ') }}
                        </template>
                        <template #cell(opciones)="{ item }">
                            <OpcionesDropdownComponent v-bind:options="[
                                { to: { name: 'back.events.acreditaciones.show', params: { evento_id: evento_id, acreditacion_id: item.id }}, label: 'Ver'},
                                ... item.estado === 1  ? [{ to: { name: 'back.events.acreditaciones.update', params: { evento_id: evento_id, acreditacion_id: item.id }}, label: 'Editar'}]: [],
                                ... item.estado === 0 || item.estado === 2 ? [{ to: { name: 'back.events.acreditaciones.activar', params: { evento_id: evento_id, acreditacion_id: item.id }}, label: 'Activar'}]: [],
                                ... item.estado === 0 || item.estado === 1 ? [{ type: 'action', action:() => showModal('cancelar-' + item.id, item), label: 'Cancelar'}]: [],
                                { type: 'action', action:() => showModal('borrar-' + item.id, item), label: 'Borrar'},
                                ... item.estado === 1 ? [{ type: 'url', url: config.API_BASE + item.url_imprimir, label: 'Imprimir acreditación'}] : [],
                            ]"/>

                            <BorrarModalComponent
                                :name="'borrar-' + item.id"
                                :title="'Borrar acreditación ' + item.nombre"
                                confirmButton="¿Está segur@ de borrar esta acreditación?"
                                v-on:close="() => closeModal('borrar-' + item.id)"
                                v-on:confirm="() => borrarAcreditacion(item.id)"
                            >
                            </BorrarModalComponent>
                            <ModalAcreditaciones
                                :name="'cancelar-' + item.id"
                                :title="'Cancelar acreditación ' + item.nombre"
                                confirmButton="¿Está segur@ de cancelar esta acreditación?"
                                buttom="CANCELAR ACREDITACIÓN"
                                @close="closeModal('cancelar-' + item.id)"
                                @confirm="cancelarAcreditacion"
                            >
                            </ModalAcreditaciones>
                        </template>
                    </b-table>
                </div>
            </div>
            <LoaderComponent v-else></LoaderComponent>
        </template>
    </MainContentSearchable>
</template>

<script>
import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
import OpcionesDropdownComponent from "@/components/backend/components/OpcionesDropdownComponent";
import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent"
import ModalAcreditaciones from "@/components/backend/eventos/acreditaciones/ModalAcreditaciones"

export default {
    props: ['evento', 'evento_id'],
    data() {
        return {
            acreditaciones: { data: [], meta: { current_page: 1 } },
            loading: false,
            fields: [
                { key: "id", label: "ID"},
                { key: "nombre", label: "Nombre" },
                { key: "medio", label: "Medio" },
                { key: "dni", label: "DNI" },
                { key: "email", label:"Email" },
                { key: "telefono", label: "Teléfono" },
                { key: "acceso_zonas", label: "Zonas" },
                { key: "servicios", label: "Staff, prensa, servicios..." },
                { key: "jornada", label: "Jornada" },
                { key: "puertas", label: "Puertas" },
                { key: "qr_code", label: "Código QR" },
                { key: "estado_texto", label: "Estado"},
                { key: "opciones", label: "Opciones", class: 'text-center' }
            ],
            filters: {
                per_page: 10,
                page: 1,
                search: ''
            },
            acreditacion: {},
        }
    },
    created() {
        this.getAcreditaciones();
        this.debouncedGetAcreditaciones = _.debounce(this.getAcreditaciones, 500)
    },
    methods: {
        getAcreditaciones() {
            this.loading = true;

            let params = {
                filters: this.filters,
                evento_id: this.evento_id
            };
            this.$store.dispatch(this.config.getVuexAlias('back.events.acreditaciones.index'), params).then(res => {
                this.acreditaciones = res.data;
            }).finally(() => this.loading = false);
        },
        borrarAcreditacion(acreditacion_id) {
            const params = {
                filters : {},
                evento_id: this.evento_id,
                acreditacion_id: acreditacion_id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.events.acreditaciones.borrar'), params).then(res => {
                this.$toast.success(res.data.message);
                this.getAcreditaciones();
            }).catch(error => {
                this.$toast.error(error.response.data.message);
            });
            this.closeModal('borrar-' + acreditacion_id);
        },
        cancelarAcreditacion(mensaje) {
            const params = {
                filters : {},
                evento_id: this.evento_id,
                acreditacion_id: this.acreditacion.id,
                cancelar: true,
                mensaje: mensaje
            };

            this.$store.dispatch(this.config.getVuexAlias('back.events.acreditaciones.activar-cancelar'), params).then(res => {
                this.$toast.success(res.data.message);
                this.getAcreditaciones();
            }).catch(error => {
                this.$toast.error(error.response.data.message);
            });
            this.closeModal('cancelar-' + this.acreditacion_id);
        },
        showModal(modal, acreditacion) {
            this.acreditacion = acreditacion;
            this.$modal.show(modal);
        },
        closeModal(modal) {
            this.$modal.hide(modal);
        },
        url_imprimir_todas() {
            return this.config.API_BASE+ '/eventos/' + this.evento_id + '/acreditaciones/imprimir?api_key='+ localStorage.getItem('token');
        }
    },
    components: {
        MainContentSearchable, OpcionesDropdownComponent, BorrarModalComponent, ModalAcreditaciones
    }
}
</script>